import type { ReminderRecurrenceUnit } from '../../services/api';
import { i18nService, t } from '../../services/i18n';

export type ReminderFilterStatus = 'all' | 'open' | 'completed';

export function esc(str: string): string {
  const el = document.createElement('span');
  el.textContent = str;
  return el.innerHTML;
}

export function formatRecurrence(value?: number, unit?: ReminderRecurrenceUnit): string {
  if (!value || !unit) return '';

  switch (unit) {
    case 'day':
      return value === 1 ? t('reminder.recurrenceEveryDay') : t('reminder.recurrenceEveryNDays', { count: value });
    case 'month':
      return value === 1 ? t('reminder.recurrenceEveryMonth') : t('reminder.recurrenceEveryNMonths', { count: value });
    case 'year':
      return value === 1 ? t('reminder.recurrenceEveryYear') : t('reminder.recurrenceEveryNYears', { count: value });
    default:
      return '';
  }
}

export function formatDate(dateStr: string): string {
  if (!dateStr) return '-';
  return i18nService.formatDate(dateStr, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function getDaysUntil(dueDate: string): number {
  return Math.ceil((new Date(dueDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}

export function isDueSoon(dueDate: string): boolean {
  const days = getDaysUntil(dueDate);
  return days <= 7 && days >= 0;
}

export function isOverdue(dueDate: string): boolean {
  return getDaysUntil(dueDate) < 0;
}
